import theme from '../../../lib/theme';

const {
  scale,
  media,
  colors,
  layouts,
  layers,
  corners,
  shadows,
  animations,
} = theme;

export default () => ({
  container: {
    ...layouts.spacedRow('xxs'),

    animation: `200ms ${animations.fadeIn} linear`,
    justifyContent: 'space-between',
    bottom: 0,
    left: 0,
    width: '100vw',
    backgroundColor: colors.black,
    position: 'fixed',
    padding: scale.xs,
    boxShadow: shadows.high,
    zIndex: layers.higher,

    [media.s.up]: {
      bottom: scale.xs,
      borderRadius: corners.m,
      width: 'auto',
      left: '50vw',
      transform: 'translateX(-50%)',
    },
  },
});
